import { NetTask } from "@/constants/netEvent.ts";
import { reqPost } from "@/service/clientRequest.ts";

export async function GetMyTaskActivityInfo() {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  return reqPost<{}, any>(
    // return reqPost<null, GetMyTaskActivityInfoRsp>(
    {},
    NetTask.mod,
    NetTask.GetMyTaskActivityInfo,
    true,
  );
}

export async function GetUserTaskReward(params: { record_id: number }) {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  return reqPost<{ record_id: number }, any>(
    // return reqPost<null, GetMyTaskActivityInfoRsp>(
    params,
    NetTask.mod,
    NetTask.GetUserTaskReward,
    true,
  );
}

export async function CompleteOnceTask(params: { task_type: number }) {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  return reqPost<{ task_type: number }, any>(
    // return reqPost<null, GetMyTaskActivityInfoRsp>(
    params,
    NetTask.mod,
    NetTask.CompleteOnceTask,
    true,
  );
}

// export const postGetMyTaskActivityInfo = async () => {
//   return reqPost<Record<string, never>, GetMyTaskActivityInfoRsp>(
//     {},
//     NetTask.mod,
//     NetTask.GetMyTaskActivityInfo,
//     true,
//   );
// };
